import './styles.scss'

import { useTranslation } from 'react-i18next'

const emptyTechnicalData = []

const TechnicalData = (props) => {
  const { t } = useTranslation()
  const { anchorId = '', technicalData = emptyTechnicalData } = props

  const renderTechnicalDataTable = () =>
    technicalData.map((item, index) => {
      if (item) {
        const key = `${item?.name}-${index}`

        return (
          <tr key={key}>
            <td>
              {item?.name} {item?.unit ? `(${item?.unit})` : ''}
            </td>
            <td>{item?.value}</td>
          </tr>
        )
      }

      return null
    })

  return (
    <div className="technical-data__wrapper pt-4 pb-4">
      <h3 id={anchorId}>{t('productDetails.technicalData')}</h3>
      <table className="technical-data__table mt-4">
        <tbody>{renderTechnicalDataTable()}</tbody>
      </table>
    </div>
  )
}

export default TechnicalData
